import { CustomerRouteFetcherQuery } from "@/gql/graphql";
import { routeAgreementCanBeEditedByStatusCode } from "@/lib/RouteAgreementCalculator";

export const routeAgreementCanBeBulkUpdated = (
  routeAgreement: Pick<
    CustomerRouteFetcherQuery["productPrice"]["routeAgreement"]["byHeadAgreementAndRoutePair"]["0"],
    "statusCode"
  >
): boolean => routeAgreementCanBeEditedByStatusCode(routeAgreement.statusCode);
